import {
	FaGithub,
	// FaGoogleScholar,
	FaLinkedinIn,
	FaRegEnvelope,
	FaStackOverflow,
	FaXTwitter,
} from "react-icons/fa6";

import { SITE, SOCIALS } from "../../data/site";

const ICONS = {
	linkedin: FaLinkedinIn,
	x: FaXTwitter,
	stackoverflow: FaStackOverflow,
	// scholar: FaGoogleScholar,
	github: FaGithub,
	email: FaRegEnvelope,
};

const Footer = () => (
	<footer className="site-footer">
		<div className="footer-inner">
			<div
				style={{
					display: "flex",
					flexWrap: "wrap",
					gap: "32px",
					justifyContent: "space-between",
					alignItems: "flex-end",
				}}
			>
				<div>
					<div
						className="seclabel"
						style={{ letterSpacing: "0.14em", marginBottom: "18px" }}
					>
						Get in touch
					</div>
					<div
						style={{ display: "flex", flexWrap: "wrap", gap: "12px" }}
					>
						{SOCIALS.map((social) => {
							const Icon = ICONS[social.icon];
							return (
								<a
									key={social.icon}
									href={social.link}
									className="icon-btn"
									aria-label={social.label}
									title={social.label}
									{...(social.link.startsWith("mailto:")
										? {}
										: {
												target: "_blank",
												rel: "noreferrer",
										  })}
								>
									<Icon aria-hidden="true" />
								</a>
							);
						})}
					</div>
				</div>
				<div className="secmeta">{SITE.email}</div>
			</div>
			<div
				className="secmeta"
				style={{
					fontSize: "10px",
					marginTop: "clamp(40px, 6vw, 64px)",
				}}
			>
				© {new Date().getFullYear()} {SITE.name} · {SITE.location}
			</div>
		</div>
	</footer>
);

export default Footer;
